export default __webpack_public_path__ + "static/media/paris.faaa2076.svg";